import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { getUser } from '../redux/authSlice';
import { getCurrentTherapist } from '../redux/therapistSlice';
import { CircularProgress, Box } from '@mui/material';

const ProtectedRoute = ({ children, allowedTypes = [], requireAuth = true }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [userChecked, setUserChecked] = useState(false);

  // Redux state'leri
  const { user: authUser } = useSelector((state) => state.auth);
  const { therapist } = useSelector((state) => state.therapist);

  // localStorage'dan bilgileri al
  const token = localStorage.getItem('token');
  const userType = localStorage.getItem('userType');

  // Mevcut kullanıcı bilgilerini belirle
  const getCurrentUserInfo = () => {
    if (userType === 'therapist' && therapist) {
      return {
        user: therapist,
        type: 'therapist',
        isAuthenticated: true
      };
    } else if (userType === 'admin' && authUser) {
      return {
        user: authUser,
        type: 'admin',
        isAuthenticated: true
      };
    } else if (authUser) {
      return {
        user: authUser,
        type: userType || 'user',
        isAuthenticated: true
      };
    } else if (token && userType) {
      return {
        user: null,
        type: userType,
        isAuthenticated: true
      };
    }
    
    return {
      user: null,
      type: null,
      isAuthenticated: false
    };
  };

  const { type, isAuthenticated } = getCurrentUserInfo();

  // Kullanıcı bilgilerini kontrol et ve getir
  useEffect(() => {
    const checkUser = async () => {
      if (token && !userChecked) {
        try {
          if (userType === 'therapist' && !therapist) {
            await dispatch(getCurrentTherapist());
          } else if ((userType === 'user' || userType === 'admin') && !authUser) {
            await dispatch(getUser());
          }
        } catch (error) {
          console.error('Kullanıcı bilgileri alınamadı:', error);
          // Token geçersizse temizle
          localStorage.removeItem('token');
          localStorage.removeItem('userType');
        }
        setUserChecked(true);
      } else {
        setUserChecked(true);
      }
      setLoading(false);
    };

    checkUser();
  }, [dispatch, token, userType, therapist, authUser, userChecked]);

  // Loading durumunda spinner göster
  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  // Auth gerektiren sayfa ama kullanıcı giriş yapmamış
  if (requireAuth && !isAuthenticated) {
    const loginPath = allowedTypes.includes('therapist') ? '/signInTherapist' : '/signIn';
    return <Navigate to={loginPath} state={{ from: location }} replace />;
  }

  // Type kontrolü - eğer allowedTypes belirtilmişse kontrol et
  if (requireAuth && allowedTypes.length > 0) {
    if (!type || !allowedTypes.includes(type)) {
      // Kullanıcının type'ına göre ana sayfasına yönlendir
      const redirectPath = getRedirectPath(type);
      return <Navigate to={redirectPath} replace />;
    }
  }

  // Her şey tamam, component'i render et
  return children;
};

// Kullanıcı type'ına göre yönlendirme path'i belirle
const getRedirectPath = (type) => {
  if (!type) {
    return '/';
  }
  
  switch (type) {
    case 'admin':
      return '/adminHome';
    case 'therapist':
      return '/therapistHomePage';
    case 'user':
    default:
      return '/userHomePage';
  }
};

export default ProtectedRoute;
